import React from 'react';
import { ChakraV3 } from '..';

interface Props extends ChakraV3.BoxProps {
  scrollRef?: React.RefObject<HTMLDivElement>;
}

export const ScrollArea = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, scrollRef, ...rest } = props;

  return (
    <ChakraV3.ScrollArea.Root ref={ref} w='auto' h='full' {...rest}>
      <ChakraV3.ScrollArea.Viewport ref={scrollRef}>
        <ChakraV3.ScrollArea.Content>{children}</ChakraV3.ScrollArea.Content>
      </ChakraV3.ScrollArea.Viewport>
      <ChakraV3.ScrollArea.Scrollbar>
        <ChakraV3.ScrollArea.Thumb bg='gray.400' />
      </ChakraV3.ScrollArea.Scrollbar>
      <ChakraV3.ScrollArea.Corner />
    </ChakraV3.ScrollArea.Root>
  );
});
